import React, { lazy } from 'react';
import { Route } from 'react-router-dom';

const BirthdayRequestFlow = lazy(() => import(/* webpackChunkName: "birthday-request-flow" */ 'pages/birthday-request'));

const renderBirthdayRequestRoutes = () => [
  <Route
    key="birthday-request"
    name="birthday-request"
    path="/birthday/request/:step"
    element={<BirthdayRequestFlow/>}
  />
];


export default renderBirthdayRequestRoutes;
